<template>
  <v-col
    cols="auto"
    :class="{ 'error--text': exceedsLimit }"
  >
    {{ counterText }}
  </v-col>
</template>

<script>
export default {
  name: "WordCounter",
  props: {
    wordsCount: {
      type: Number,
      required: false,
      default: 0,
    },
    charsCount: {
      type: Number,
      required: false,
      default: 0,
    },
    limitedContent: {
      type: Boolean,
      default: false,
    },
    limitCount: {
      type: Number,
      default: 0,
    },
    limitType: {
      type: String,
      default: "",
    },
  },
  inject: ["wordsCount", "charsCount"],
  computed: {
    exceedsLimit() {
      if (!this.limitedContent) return false

      if (this.limitType === "words") {
        return this.wordsCount >= this.limitCount
      } else {
        return this.charsCount >= this.limitCount
      }
    },
    counterText() {
      if (!this.limitedContent) {
        return `${
          this.wordsCount +
          " " +
          this.$t("quiz.editor.wordsLimit.words").toLowerCase()
        }`
      }

      let limit = this.limitCount

      if (this.limitType === "words") {
        return `${
          this.wordsCount +
          "/" +
          limit +
          " " +
          this.$t("quiz.editor.wordsLimit.words").toLowerCase()
        }`
      } else {
        return `${
          this.charsCount +
          "/" +
          limit +
          " " +
          this.$t("quiz.editor.wordsLimit.charactersShort")
        }`
      }
    },
  },
}
</script>
